// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wxDf","fullView":"styles_fullView__2YiBu"};